import { Storage } from 'aws-amplify';
import FileStorage from '@/entities/FileStorage';

export default class ProdStorage implements FileStorage {
	get(filename: string): Promise<string> {
		return Storage.get(filename) as Promise<string>; // returns string because download=false by default
	}

	save(
		fileName: string,
		fileData: Buffer,
		onProgress: (progress: number) => void
	) {
		return Storage.put(fileName, fileData, {
			progressCallback: (progress) => {
				if (progress.total) {
					const percentage = Math.round(
						(progress.loaded / progress.total) * 100
					);
					onProgress(percentage);
				}
			},
		}) as Promise<AWS.S3.PutObjectOutput | AWS.AWSError>;
	}

	delete(fileName: string) {
		return Storage.remove(fileName);
	}
}
